import React, { FunctionComponent } from 'react';
import { Link, makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/infoBannerStyles';
import Info from '@material-ui/icons/InfoOutlined';
import { BodyM, BodyMBold, BodyS } from 'components/Typography/Typography';
import Close from '@material-ui/icons/Close';

//@ts-ignore
const useStyles = makeStyles(styles);

interface IInfoBanner {
	message?: string;
	backgroundColor?: string;
	showCloseButton?: boolean;
	linkHandler?: Function;
	handleClose?: Function;
	link?: string;
	linkPath?: string;
}

const InfoBanner: FunctionComponent<IInfoBanner> = ({
	message = '',
	showCloseButton,
	backgroundColor,
	handleClose,
	link,
	linkHandler,
	linkPath,
}) => {
	const classes = useStyles({ backgroundColor });

	return (
		<div className={classes.infoMessageContainer}>
			<div className={classes.infoiconWrapper}>
				<Info className={classes.infoicon} />
			</div>
			<div className={classes.messageWrapper}>
				<BodyM disableMargin>{message}</BodyM>
				{link && (
					<Link
						className={classes.link}
						onClick={() => {
							if (linkHandler) {
								linkHandler();
							}
						}}
					>
					<BodyMBold disableMargin customClassName={classes.bannerLink}>{link}</BodyMBold>
					</Link>
				)}
			</div>
			{showCloseButton && (
				<div className={classes.closeButton} onClick={() => handleClose && handleClose()}>
					<Close data-testid="close-button" />
				</div>
			)}
		</div>
	);
};

export default InfoBanner;
